import { render, staticRenderFns } from "./RegistrationAndVotingByJobType.vue?vue&type=template&id=2bc3cbc2&scoped=true"
import script from "./RegistrationAndVotingByJobType.vue?vue&type=script&lang=js"
export * from "./RegistrationAndVotingByJobType.vue?vue&type=script&lang=js"
import style0 from "./RegistrationAndVotingByJobType.vue?vue&type=style&index=0&id=2bc3cbc2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc3cbc2",
  null
  
)

export default component.exports